module.exports = __webpack_public_path__ + "img/1412.93061c59.jpg";